<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import { FEATURE_LABEL_MAP, LICENSE_TO_FEATURE } from "./assets";
  import RegisterInterestModal from "./RegisterInterestModal.svelte";
  import { showRegisterInterestModal } from "./stores";

  let { license } = $props();

  const onclick = async () => {
    $showRegisterInterestModal = true;
  };

  let feature = LICENSE_TO_FEATURE[license];
  let requestFlag = FEATURE_LABEL_MAP[feature];
</script>

{#if $userStore[requestFlag]}
  <Tooltip let:onmouseenter let:onmouseleave>
    <div {onmouseenter} {onmouseleave} role="presentation">
      <Button kind="primary disabled" size="large" disabled
        >Request Access</Button
      >
    </div>
    <span slot="tooltip">Full access to {feature} has been requested</span>
  </Tooltip>
{:else}
  <Button kind="upgrade" size="large" {onclick}>Request Access</Button>
{/if}

{#if $showRegisterInterestModal}
  <RegisterInterestModal {license} />
{/if}
